import { DISPLAY_VIEWPORT, DISPLAY_REM } from 'Components/frameworks/image/constants';
export const OFFER_STYLE = 'w-[85vw]  max-w-380';
export const RATIO_DISPLAYS = [
  {
    value: 1 / 3,
    unit: DISPLAY_REM,
  },
  {
    value: 380,
    unit: 'px',
  },
  {
    value: 380,
    unit: 'px',
  },
  {
    value: 85 / 100,
    unit: DISPLAY_VIEWPORT,
  },
];
